import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-body-1 font-weight-bold mt-2" }

import { ref, watch } from "vue";

//eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalValidarPartida',
  props: {
  isVisible: Boolean,
  idPartidaTorneo: Number,
  usuario: Number,
  // El resultado que se valida, por ejemplo «Aragorn 11 - 7 Legolas»
  resumen: String,
},
  emits: ["confirmar", "cerrar"],
  setup(__props, { emit: __emit }) {

const props = __props;

//eslint-disable-next-line no-undef
const emit = __emit;

// Variables reactivas
const isModalValidarVisible = ref(true);

// Cerrar el modal
const cerrarModal = () => {
  emit("cerrar");
};

// Confirmar los puntos y cerrar el modal
const confirmarValidar = () => {
  emit("confirmar");
  cerrarModal();
};

// Monitorea cambios en la visibilidad del modal
watch(
  () => props.isVisible,
  newVal => {
    isModalValidarVisible.value = newVal;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isModalValidarVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalValidarVisible).value = $event)),
    "max-width": "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(" Validar partida ")
            ]),
            _: 1
          }),
          (__props.resumen)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(" ¿Das por bueno este resultado? "),
                  _createElementVNode("div", _hoisted_1, _toDisplayString(__props.resumen), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                small: "",
                variant: "tonal",
                color: "primary",
                onClick: confirmarValidar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                small: "",
                variant: "tonal",
                color: "secondary",
                onClick: cerrarModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})